function cookieValue(cookieName) {
    const cookies = decodeURIComponent(document.cookie).split('; ');
    for (let i = 0, len = cookies.length; i < len; i++) {
        if (cookies[i].indexOf(cookieName + '=') === 0) {
            return cookies[i].substring((cookieName + '=').length);
        }
    }

    return null;
}

function setCookieValue(cookieName, value, expiresDays) {
    const d = new Date();
    d.setTime(d.getTime() + (expiresDays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + d.toUTCString();
    document.cookie = cookieName + '=' + value + ';' + expires + ';path=/';
}

function getQueryParams(url) {
    const queryParams = {};
    const anchor = document.createElement("a");
    anchor.href = url;
    const queryStrings = anchor.search.substring(1);
    const params = queryStrings.split("&");

    for (let i = 0; i < params.length; i++) {
        const pair = params[i].split("=");
        queryParams[pair[0]] = decodeURIComponent(pair[1]);
    }

    return queryParams;
};

function showLoader(cb) {
    $('#popupLoader').show();
    $('#popupFade').show();
    cb && cb()
}

function hideLoader(cb) {
    $('#popupLoader').hide();
    $('#popupFade').hide();
    cb && cb()
}

const lockout = {
    getScrollBarWidth: () => {
        const div = document.createElement('div');
        div.style.cssText = "overflow: auto scroll; width: 50px; height: 50px; position: absolute;";

        document.body.append(div);
        const scrollWidth = div.offsetWidth - div.clientWidth;

        div.remove();
        return scrollWidth;
    },
    setScrollbarWidthCssVar: () => document.documentElement.style.setProperty('--scrollbarWidth', `${lockout.getScrollBarWidth()}px`),
    on: () => window.site.html.addClass('lockout'),
    off: () => window.site.html.removeClass('lockout'),
    toggle: () => window.site.html.toggleClass('lockout')
}
lockout.setScrollbarWidthCssVar();

const debounce = (func, wait = 250) => {
    let timeout;
    return (event) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func(event), wait);
    };
};

const scrollTo = (offset, speed = 500) => {
    const value = parseInt(offset, 10);
    if (value < 0 && $('html, body').scrollTop !== value) {
        return;
    }

    $('html, body').animate({ scrollTop: value }, speed);
}

const getCssVar = (varName) => getComputedStyle(document.documentElement).getPropertyValue(`--${varName}`);
const breakpoints = {
    mobileLarge: parseInt(getCssVar('bpMobileLarge')),
    tablet: parseInt(getCssVar('bpTablet')),
    tabletMid: parseInt(getCssVar('bpTabletMid')),
    tabletLarge: parseInt(getCssVar('bpTabletLarge')),
    desktop: parseInt(getCssVar('bpDesktop')),
    large: parseInt(getCssVar('bpLarge')),
    exlarge: parseInt(getCssVar('bpExLarge')),
}

// For this to work without the hassle of waiting for the elements to exist throught MutationObserver/etc make sure site.js is added to the end of <body>
// Also were not exporting this object as it would need importing to *every* file, must easier just to reference the window obj
window.site = {
    doc: $(document),
    body: $('body'),
    win: $(window),
    html: $('html')
}

export {
    breakpoints,
    cookieValue,
    debounce,
    getQueryParams,
    hideLoader,
    lockout,
    scrollTo,
    setCookieValue,
    showLoader,
}
